import { isNotEmptyObject } from "./check";
export var ERROR_PAYLOAD_ATTR = '_wj_inject';
export function setTagValue(target, key, value, pre) {
    if (pre === void 0) { pre = ''; }
    target["wj" + (pre ? "_" + pre : '') + "_" + key] = value;
}
export function generateWJTags(options, isDelete) {
    if (isDelete === void 0) { isDelete = false; }
    var tags = {};
    var originTags = options.wjTags || {};
    if (isNotEmptyObject(originTags)) {
        var hasAttr_1 = false;
        Object.keys(originTags).forEach(function (key) {
            hasAttr_1 = true;
            var value = originTags[key];
            setTagValue(tags, key, value, 'global');
        });
        if (hasAttr_1 && isDelete) {
            delete options.wjTags;
        }
    }
    return tags;
}
export function generatorErrorTags(event, hint) {
    var _a, _b;
    var errorPayloadTags = (_b = (_a = hint === null || hint === void 0 ? void 0 : hint.originalException) === null || _a === void 0 ? void 0 : _a[ERROR_PAYLOAD_ATTR]) === null || _b === void 0 ? void 0 : _b.tags;
    if (isNotEmptyObject(errorPayloadTags)) {
        var tags_1 = event.tags || {};
        Object.keys(errorPayloadTags).forEach(function (key) {
            setTagValue(tags_1, key, errorPayloadTags[key], 'user');
        });
        event.tags = tags_1;
    }
}
//# sourceMappingURL=tags.js.map